/**
 * Database service for managing database information
 */

import logger from 'core/utils/logger';
import { get } from 'api/axios-client';

export interface Database {
  databaseName: string;
  companyIdentity: string;
  databaseIdentity: string;
  aspenVersion: string;
}

class DatabaseService {
  async getDatabasesByCompany(companyId: string): Promise<Database[]> {
    try {
      logger.info('Fetching databases for company', { companyId });

      // Real API call to get databases by company
      const response = await get<Database[]>(
        `Databases?companyIdentity=${companyId}`
      );

      logger.info('Databases fetched successfully', {
        companyId,
        count: response.data || 0,
      });
      return response.data || [];
    } catch (error) {
      logger.error('Failed to fetch databases', { companyId }, error as Error);
      throw error;
    }
  }
}

export const databaseService = new DatabaseService();
export default databaseService;
